// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"81131c78","123":"cbd4ef27","480":"a39ce4fe","629":"d0ab0ddf","937":"adef7341","941":"7bb3bb6c","994":"75eca7fd"}[chunkId] + ".chunk.js";
};